<template>
    <div class="buttons">
        <div class="button-controls d-flex justify-space-between">
            <v-btn prepend-icon="mdi-printer" @click="printPage">Print</v-btn>
            <div class="w-25">
                <v-select label="Week"
                          v-model="selectedWeek"
                          item-title="text"
                          item-value="startDate"
                          :items="weeks"></v-select>
            </div>
        </div>
    </div>
    <div class="book">
        <div class="page">
            <div class="subpage">
                <v-overlay :model-value="loading"
                           class="align-center justify-center">
                    <v-progress-circular color="primary"
                                         indeterminate
                                         size="64"></v-progress-circular>
                </v-overlay>
                <div v-if="data">
                    <h4 v-if="selectedWeekDetails"><small style="color: #757575;"><v-icon icon="mdi-calendar-range"></v-icon> FOR THE WEEK</small> {{ selectedWeekDetails.text }}</h4>
                    <v-sheet color="grey-lighten-4"
                             class="pa-2 mb-4"
                             rounded>
                        <div class="d-flex justify-space-between px-3">
                            <div>
                                <h5 class="text-disabled">No. REWORKS</h5>
                                <h1>{{ numberWithCommas(data.total, 0) }}</h1>
                            </div>
                            <div class="text-right">
                                <h5 class="text-disabled">TOTAL VALUE</h5>
                                <h1>${{ numberWithCommas(data.value, 2) }}</h1>
                            </div>
                        </div>
                        <div v-if="data.reworkCustomers && data.reworkCustomers.length > 0" class="day-block px-3">
                            <h5 class="text-disabled">CUSTOMERS</h5>
                            <v-row>
                                <v-col cols="6">
                                    <v-table density="compact" class="top-5-table">
                                        <tbody v-for="(topCustomer, index) in data.reworkCustomers.slice(0,3)" :key="index">
                                            <tr v-if="topCustomer">
                                                <td class="pa-0">{{ index+1 }}) {{ truncate(topCustomer.name, 15) }}</td>
                                                <td class="text-right pa-0">{{ numberWithCommas(topCustomer.total, 0) }}</td>
                                                <td class="text-right pa-0">${{ numberWithCommas(topCustomer.value, 2) }}</td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </v-col>
                                <v-col cols="6">
                                    <v-table density="compact" class="top-5-table">
                                        <tbody v-for="(topCustomer, index) in data.reworkCustomers.slice(3,6)" :key="index">
                                            <tr v-if="topCustomer">
                                                <td class="pa-0">{{ index+1 }}) {{ truncate(topCustomer.name, 15) }}</td>
                                                <td class="text-right pa-0">{{ numberWithCommas(topCustomer.total, 0) }}</td>
                                                <td class="text-right pa-0">${{ numberWithCommas(topCustomer.value, 2) }}</td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-sheet>

                    <v-sheet v-for="(line, index) in data.productionLines" :key="index" rounded class="pa-2 mb-4">
                        <div v-if="line">
                            <h3 class="border-b-sm mb-1 pb-1 px-4">Line {{ line.line }}</h3>
                            <div class="d-flex justify-space-between px-4">
                                <div>
                                    <h6 class="text-disabled">No. REWORKS</h6>
                                    <h3>{{ numberWithCommas(line.total, 0) }}</h3>
                                </div>
                                <div class="text-right">
                                    <h6 class="text-disabled">TOTAL VALUE</h6>
                                    <h3>${{ numberWithCommas(line.value, 2) }}</h3>
                                </div>
                            </div>
                            <v-table density="compact" class="top-5-table mt-1">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <td v-for="day in days" :key="day" class="week-cell text-disabled">{{ day }}</td>
                                    </tr>
                                    <tr>
                                        <td><b>TOTAL</b></td>
                                        <td v-for="(day, index) in days" :key="day" class="week-cell">
                                            {{ numberWithCommas(line.days[index].total, 0) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>VALUE</b></td>
                                        <td v-for="(day, index) in days" :key="day" class="week-cell">
                                            ${{ numberWithCommas(line.days[index].value, 2) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <div class="day-block px-3">
                                <h5 class="text-disabled border-b-sm">REWORKS</h5>
                                <div class="top-5-table">
                                    <div v-for="(job, jobIndex) in line.reworkJobs" :key="jobIndex" class="reason-block border-b-sm">
                                        <div class="d-flex justify-space-between">
                                            <div>
                                                <strong>{{ job.job }}</strong>
                                            </div>
                                            <div class="text-right">
                                                <strong>{{ job.contact }}</strong>
                                            </div>
                                        </div>
                                        {{ job.reason.replace('REWORK - ', '') }}
                                        <div v-if="job.items && job.items.length > 0">
                                            <div class="text-disabled">ITEMS</div>
                                            <div v-for="(item, itemIndex) in job.items.slice(1)" :key="itemIndex">
                                                {{ item }}
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <strong>${{ numberWithCommas(job.value, 2) }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </v-sheet>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    @import '../styles/portraitprint.scss';
    .book {
        margin-top:140px;
    }
    .v-table--density-compact > .v-table__wrapper > table > tbody > tr > .comment-box {
        height: 100px !important;
        border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
        vertical-align: top;
        padding:2px;
        width:16.6%;
    }
    .average-table {
        background: #E1F5FE;
        border-radius: 5px;
        font-weight: bold;
        border: 1px solid #01579B;
        padding: 4px;
    }
    .comment-box {
        font-size: 8px;
        border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
    }
    @media print {
        .book {
            margin-top: 0px;
            margin-bottom:0px;
            background-color:white;
        }
        #app html body .v-application__wrap {
            background-color: white;
        }
        .page {
            min-height:auto;
            padding-top:5px;
        }
    }
    .number-cell {
        text-align: right !important;
    }

    .footnote-text {
        font-size: 12px;
    }
    .week-table {
        font-size:13px;
    }
    .week-cell {
        width: 14.28%;
    }
    .top-5-table {
        font-size:11px;
    }
    .reason-block {
        margin-bottom:10px;
    }
    .v-table--density-compact > .v-table__wrapper > table > tbody > tr > td, .v-table--density-compact > .v-table__wrapper > table > tbody > tr > th {
        height: 17px !important;
    }
    .day-block {
        border-top: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
        margin-top:5px;
        padding-top:5px;
    }
</style>
<script>
    import { mapActions, mapState } from "vuex";
    import { getTagClass } from '../mixins/jobMixins';
    import { truncate } from '../mixins/stringMixins';
    var weekday = require("dayjs/plugin/weekday");
    var isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
    import { numberWithCommas } from "../mixins/numberMixins";
    function initialState() {
        return {
            loading: false,
            weeks: [],
            errors: '',
            data: null,
            selectedWeek: null,
            days: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
        };
    }
    export default {
        name: "WeeklyProductionSummary",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.$dayjs.extend(weekday);
            this.$dayjs.extend(isSameOrBefore);
            let currentDate = this.$dayjs().weekday(0); // Start from the last Sunday
            for (let i = 0; i < 12; i++) {
                const startDate = currentDate.startOf('week').add(1, 'day'); // Monday
                const endDate = currentDate.endOf('week').add(1, 'day'); // Sunday

                this.weeks.unshift({
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                    text: `${startDate.format('D MMMM')} - ${endDate.format('D MMMM')}`
                });

                currentDate = currentDate.subtract(1, 'week'); // Move to the previous week
            }
            this.weeks = this.weeks.reverse();
            this.selectedWeek = this.weeks[0].startDate;
        },
        props: {
        },
        methods: {
            ...mapActions([
                'showErrorSnack'
            ]),
            truncate,
            numberWithCommas,
            getTagClass,
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            printPage() {
                var css = '@page { size: A4 portrait!important; }',
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style');

                style.type = 'text/css';
                style.media = 'print';

                if (style.styleSheet){
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
                window.print();
            },
            loadReport(){
                this.loading = true;
                let query = [];
                if (this.selectedWeekDetails) {
                    query.push('startDate='+this.selectedWeekDetails.startDate);
                    query.push('endDate='+this.selectedWeekDetails.endDate);
                }
                this.$api.get('report/weeklyreworksumm?' + query.join('&'))
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue getting the report data");
                    });
            },
        },
        computed: {
            selectedWeekDetails() {
                if (this.selectedWeek) {
                    return this.weeks.find(week => week.startDate === this.selectedWeek);
                }
                return null;
            }
        },
        watch: {
            selectedWeek: {
                handler() {
                    this.loadReport();
                }
            }
        }
    };
</script>